import { inputService } from "../../../../modules/inputs/input/InputService";
import { inputKeyMappingService } from "../../../../modules/inputs/input/InputKeyMappingService";
import { localizationService } from "../../../../modules/localization";
import { InputKeyDetailsDeviceEnum } from "../../../../modules/inputs/input/InputKeyDetails";
import { BUTTON_MAPPING } from "../../../../modules/inputs/devices/InputMapping";
import { ButtonType, InputDeviceType } from "flavr-common";
function createTrigger(keyDetails, modifiers) {
    if (keyDetails.deviceType.type !== InputKeyDetailsDeviceEnum.Keyboard)
        return undefined;
    return () => inputService.emulateKeyPress(keyDetails.keyName, modifiers);
}
function createControlString(keyInfo, keyDetails) {
    let control = "";
    if (keyInfo.shift) {
        control += "shift + ";
    }
    if (keyInfo.ctrl) {
        control += "ctrl + ";
    }
    if (keyInfo.alt) {
        control += "alt + ";
    }
    if (keyInfo.cmd) {
        control += "cmd + ";
    }
    control += keyDetails.descriptionName;
    return control;
}
// TODO: refactor inputKeyMappingService, this is way too complicated
function createActionControlsInfoArray(type) {
    const actionMapping = [];
    for (const data of inputService.getCurrentKeyActionBindingIterator()) {
        if ((data.hasDevKey && type === "standard") || (!data.hasDevKey && type === "expert"))
            continue;
        const controls = [];
        let trigger;
        for (const keyInfo of data.keys) {
            const keyDetails = inputKeyMappingService.getKeyDetailsByIndex(keyInfo.key);
            if (!keyDetails)
                continue;
            controls.push(createControlString(keyInfo, keyDetails));
            trigger !== null && trigger !== void 0 ? trigger : (trigger = createTrigger(keyDetails, keyInfo));
        }
        actionMapping.push({
            name: data.description ? localizationService.getTranslation(data.description) : data.actionName,
            controls,
            trigger
        });
    }
    for (const action of inputService.getActionIterator()) {
        if ((action.hasDevKey() && type === "standard") || (!action.hasDevKey() && type === "expert"))
            continue;
        const controls = [];
        let trigger;
        for (const [key, data] of action.getKeyIterator()) {
            const keyDetails = inputKeyMappingService.getKeyDetails(key);
            if (!keyDetails)
                continue;
            controls.push(createControlString(data, keyDetails));
            trigger !== null && trigger !== void 0 ? trigger : (trigger = createTrigger(keyDetails, data));
        }
        actionMapping.push({
            name: action.description ? localizationService.getTranslation(action.description) : action.name,
            controls,
            trigger
        });
    }
    // Old mapping
    if (type === "standard") {
        const keyboardMapping = BUTTON_MAPPING[InputDeviceType.Keyboard];
        for (const key in keyboardMapping) {
            const buttonType = keyboardMapping[key];
            const info = inputKeyMappingService.getActionInfo(buttonType);
            if (!info)
                continue;
            const type = ButtonType[buttonType];
            const keyName = key === " " ? "Space" : key;
            const controls = [`${keyName}`];
            actionMapping.push({
                name: info.description ? localizationService.getTranslation(info.description) : type,
                controls
            });
        }
    }
    return actionMapping;
}
export function createStandardControlsInfoArray() {
    return createActionControlsInfoArray("standard");
}
export function createExpertControlsInfoArray() {
    return createActionControlsInfoArray("expert");
}
export function createMovementControlsInfoArray() {
    const axisMapping = [];
    for (const data of inputService.getCurrentAxisBindingIterator()) {
        const posControls = [];
        const negControls = [];
        for (const [keyName, scale] of data.axisData.mappings) {
            const keyDetails = inputKeyMappingService.getKeyDetails(keyName);
            if (!keyDetails)
                continue;
            const control = localizationService.getTranslation(keyDetails.descriptionName);
            if (scale >= 0) {
                posControls.push(control);
            }
            else {
                negControls.push(control);
            }
        }
        const descriptivePositiveName = data.axisData.descriptivePositiveName ? data.axisData.descriptivePositiveName : { key: "ui.input.positive" };
        const descriptiveNegativeName = data.axisData.descriptiveNegativeName ? data.axisData.descriptiveNegativeName : { key: "ui.input.negative" };
        axisMapping.push({
            name: localizationService.getTranslation(descriptivePositiveName),
            controls: posControls
        });
        axisMapping.push({
            name: localizationService.getTranslation(descriptiveNegativeName),
            controls: negControls
        });
    }
    return axisMapping;
}
